module.exports = __webpack_public_path__ + "static/media/EID-adha-2024-en.0db65da9.jpg";